export const viewInstructionsConstants = {
  instructionMinDate: '01/01/0001'
};
